import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { getStatsConsult } from '../services/consultService/getStatsConsult'

export const useStatsConsult = () => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['consults', 'stats'],
    queryFn: getStatsConsult,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title:
          'Erro ao carregar as estatísticas de consulta, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
  }
}
